import { useContext } from "react";
import { ProviderAttachmentsContext } from "./ProviderAttachmentsContext";

export const useOptionalProviderAttachments = () =>
  useContext(ProviderAttachmentsContext);
